import {injectable} from "inversify";
import {ShopService} from "@/services/shop-service";
import {TabbedPanel} from "@/scenes.ui/tabbed-panel";
import {Tr} from "@/i18n/i18n";
import ShopStore from "@/store/shop";
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {ShopElephant, ShopRankDto} from "@/store/shop/types";
import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {HeroShopService} from "@/services/hero-shop-service";
import Container = Phaser.GameObjects.Container;
import SoundUtils from "@/utils/sound-utils";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {ConfirmationPanel} from "@/scenes.ui/confirmation-panel";
import {Keys} from "@/constants/key";
import ListenerManager from "@/managers/listener-manager";
import {ShopElephPanel} from "@/scenes.ui/shop-eleph-panel";

@injectable()
export class CaviarElephShopService extends ShopService {

    protected createTabbedPanel(): TabbedPanel {
        let self = this;
        return new TabbedPanel(this.scene!, this.canvas!, Tr('s.e'), ['bank', 'heroes'],
            [Tr('bank'), Tr('offs')], [true, true], this.selectSound, (tabId: string) => {
                if (tabId === 'bank') {
                    this.populateBankTab();
                } else if (tabId === 'heroes') {
                    this.populateHeroesTab();
                }
            }, () => {}, () => self.closeCallback());
    }

    protected populateHeroesTab(): void {
        let self = this;

        let player = PlayerStore.getPlayer()!;
        this.setupHeroAgitations(player);

        ShopStore.fetchCaviarShopElephs().then((ranks: ShopElephant[]) => {
            let panels: Container[] = [];
            let self = this;

            panels.push(...HeroShopService.getTopTextsByTabId(this.scene!, this.canvas!));

            let panelY = 0;
            ranks.forEach(r => {

                let scp = new ShopElephPanel(this.scene!, 0, panelY, r, () => {
                    if (PlayerStore.getPlayer().caviar < r.price) {
                        SoundUtils.play(self.levelUpSound);
                        new FeedbackPanel(self.scene!, Tr('n.e.c'), self.tabbedPanel!, false).show();
                    } else {
                        let cp = new ConfirmationPanel(self.scene!, self.canvas!, () => {
                            ShopStore.buyCaviarShopEleph(r.id).then(() => {
                                ListenerManager.callPurchaseRecievedCallbacl();
                                new FeedbackPanel(self.scene!, Tr('success.purch'), undefined, true).show();
                            });
                        }, Tr('podtverzhdenie'), r.description, Keys.UI_GOLDEN_CHECK, Tr('da'), Tr('net'), Keys.ATLAS_PROFILE);
                        cp.openAnimated();
                    }
                });

                panels.push(scp);
                panelY += ShopCreaturePanel.HEIGHT;
            });

            this.tabbedPanel.supplyChildren('heroes', panels);
        });
    }

    protected setupHeroAgitations(player: Player) {
        this.tabbedPanel.setAgitationText(Tr('have.cav') + player.caviar);
    }
}
